import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import _ from 'lodash';
import { useRef } from 'react';
import * as Yup from 'yup';
// import { Alert } from '../../../../store';
import type { Device, Installer } from '../../../model';
import { useUpdateDevicesLater, useUpdateDevicesNow } from '../graphql';

export interface Props {
  installers: Installer[];
  locations: Device[];
  onClose: () => void;
}

interface Values {
  ids: string[];
  ems: boolean;
  emsVersion?: Installer;
  lcs: boolean;
  lcsVersion?: Installer;
  updater: boolean;
  updaterVersion?: Installer;
  updateNow: boolean;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
//   alert: Alert;
}

// validate if checkbox is selected and require dropdown/select
const validationSchema = Yup.object({
  ems: Yup.boolean(),
  lcs: Yup.boolean(),
  updater: Yup.boolean(),
  emsVersion: Yup.object().when('ems', {
    is: (ems: boolean) => ems,
    then: (schema) => schema.required('EMS Version is required.')
  }),
  lcsVersion: Yup.object().when('lcs', {
    is: (lcs: boolean) => lcs,
    then: (schema) => schema.required('LCS Version is required.')
  }),
  updaterVersion: Yup.object().when('updater', {
    is: (updater: boolean) => updater,
    then: (schema) => schema.required('Updater Version is required.')
  })
});

export const useForm = ({ locations, onClose }: Props): Form => {
  const [mutationLater, updateLater] = useUpdateDevicesLater();
  const [mutationNow, updateNow] = useUpdateDevicesNow();

//   const alert = Alert.useAlert(error);

  const initialValues = useRef({
    updateNow: false,
    ids: locations.map(v => v.id),
    ems: false,
    emsVersion: undefined,
    lcs: false,
    lcsVersion: undefined,
    updater: false,
    updaterInstaller: undefined
  }).current;


  const formik = useFormik<Values>({
    initialValues,
    validationSchema,
    validateOnMount: true,

    /*
     * validate(): void {
     *   alert.hide();
     * },
     */

    async onSubmit(data: Values): Promise<void> {
        // alert.hide();
        const updateAt = new Date();

        updateAt.setHours(4);

        const variables = {
            locations: data.ids, // encoders
            schedules: <{ id: string; updateAt: Date }[]>[]
        };

        if (data.ems && data.emsVersion) {

            variables.schedules.push({ id: data.emsVersion.id, updateAt });
        }

        if (data.lcs && data.lcsVersion) {
            variables.schedules.push({ id: data.lcsVersion.id, updateAt });
        }

        if (data.updater && data.updaterVersion) {
            variables.schedules.push({ id: data.updaterVersion.id, updateAt });
        }

        // select Mutation
        const mutation = data.updateNow ? mutationNow : mutationLater;

        if ((!data.lcs && !data.ems && !data.updater) || await mutation(variables)) {
          onClose();
        }
    }
  });

  return {
    formik,
    loading: formik.values.updateNow ? updateNow.loading : updateLater.loading
    // alert
  };
};
